import { type TeamChatPoster } from '@littlebird/sdk';

import { WikiUserAvatar } from '@/features/people-wiki/components/user-avatar';

const SHOWN_FACES = 3;

/** The faces of the people who posted, so a chat with teammates in it is told apart from one without */
export function TeamChatFaces({
  posters,
}: {
  readonly posters: readonly TeamChatPoster[];
}) {
  if (posters.length === 0) return null;
  const hidden = posters.length - SHOWN_FACES;
  return (
    <span
      className="flex shrink-0 items-center -space-x-1.5"
      aria-label={`Posted by ${posters.map((poster) => poster.name).join(', ')}`}
    >
      {posters.slice(0, SHOWN_FACES).map((poster) => (
        <WikiUserAvatar
          key={poster.userId}
          userId={poster.userId}
          name={poster.name}
          className="size-4 text-[0.4375rem] ring-1 ring-surface"
        />
      ))}
      {hidden > 0 && (
        <span className="pl-2 text-[0.625rem] text-foreground-muted">
          +{hidden}
        </span>
      )}
    </span>
  );
}
